import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { initMockDb } from '@ascend/mocked-shared/mock-data';
import { MockDataDisclaimer } from '@ascend/mocked-shared/components';
import { PasswordGate } from '@ascend/shared/components';
import { AuthProvider } from './contexts/AuthContext';
import { App } from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

async function bootstrap() {
  await initMockDb();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <PasswordGate expectedHash={import.meta.env.VITE_PASSWORD_GATE_HASH} storageKey="ascend-admin-password-gate-v1">
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <App />
              <MockDataDisclaimer storageKey="ascend-admin-mock-disclaimer-v1" />
              <Toaster position="top-right" richColors />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </PasswordGate>
    </StrictMode>,
  );
}

void bootstrap();
